import { Auth } from 'aws-amplify';
import createAwsClient from 'agnostic-aws-signature';

const AuthService = {
  async getSignedRequest(endpoint) {
    const AWS_REGION = 'us-east-1';

    try {
      const { accessKeyId, secretAccessKey, sessionToken } =
        await Auth.currentCredentials();

      const AWSConfig = { region: AWS_REGION, endpoint };

      const awsClient = createAwsClient(
        accessKeyId,
        secretAccessKey,
        sessionToken,
        AWSConfig
      );

      const signedRequest = awsClient.signRequest({
        method: 'GET', // Method of your request
        headers: {
          // Whatever headers you need to send to the resource
          accept: '*/*',
          'content-type': 'application/json',
        }, // Whatever body you need to send to the resource
      });

      return signedRequest;
    } catch (e) {
      return {};
    }
  },
};

export default AuthService;
